import { useCallback, useState } from 'react';

import { ReactNativeProps } from './nativeProps';
import useNativeEventListener, { EikaMessageEvent, parseCallback } from './useNativeEventListener';

const useReactNativeProps = (): ReactNativeProps => {
    const [props, setProps] = useState(window?.ReactNativeProps ?? {});

    const updateReactNativeProps = useCallback((event: EikaMessageEvent<'REACT_NATIVE_PROPS_UPDATED'>) => {
        const data = parseCallback(event.data);
        if (data?.action === 'REACT_NATIVE_PROPS_UPDATED' && window?.ReactNativeProps) {
            setProps(window.ReactNativeProps);
        }
    }, []);

    useNativeEventListener(updateReactNativeProps);
    return props;
};

export default useReactNativeProps;
